import { QueryClient } from "react-query";
import { persistQueryClient } from "react-query/persistQueryClient-experimental";
import { createWebStoragePersistor } from "react-query/createWebStoragePersistor-experimental";
import { onError } from "./Helpers";
import { encrypt, decrypt } from "./SecureStorage";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 60 * 24,
      onError,
      retry: false,
    },
    mutations: {
      onError,
    },
  },
});

// Clean up legacy insecure query cache in localStorage if exists
if (typeof window !== "undefined" && window.localStorage) {
  try {
    window.localStorage.removeItem("REACT_QUERY_OFFLINE_CACHE");
  } catch (e) {
    console.error("Failed to clean up legacy localStorage query cache:", e);
  }
}

const sessionStoragePersistor = createWebStoragePersistor({
  storage: window.sessionStorage,
  serialize: (client) => {
    const stringified = JSON.stringify(client);
    return encrypt(stringified);
  },
  deserialize: (cachedString) => {
    const decrypted = decrypt(cachedString);
    if (!decrypted) return {} as any;
    try {
      return JSON.parse(decrypted);
    } catch (e) {
      console.error("Failed to parse decrypted query cache:", e);
      return {} as any;
    }
  },
});

persistQueryClient({
  queryClient,
  persistor: sessionStoragePersistor,
});
